import { getIconEntry } from '@/constants/proficiencyIconCatalog';

export const LevelIconPreview = ({
    icon,
    iconUrl,
    iconColor,
    className = 'h-6 w-6',
}: {
    icon: string;
    iconUrl?: string | null;
    iconColor?: string | null;
    className?: string;
}) => {
    if (iconUrl) {
        return (
            <img
                src={iconUrl}
                alt={''}
                className={`${className} object-contain`}
            />
        );
    }

    const entry = getIconEntry(icon);
    if (!entry) {
        return null;
    }

    return (
        <svg
            className={`${className} ${iconColor ? '' : entry.colorClass}`}
            style={iconColor ? { color: iconColor } : undefined}
            viewBox={'0 0 24 24'}
            stroke={'currentColor'}
        >
            {entry.paths}
        </svg>
    );
};
